import axios from "axios";

const isPro = Object.is(process.env.NODE_ENV, 'production')
const baseUrl = isPro ? 'https://4test.jxhnznsb.com/' : 'https://4test.jxhnznsb.com/'//https://api.shop.eduwork.cn

const instance = axios.create({
    
    baseURL: baseUrl,
    timeout: 5000,
    // headers: {'X-Custom-Header': 'foobar'}
})
/**
 * 请求拦截
 */
instance.interceptors.request.use(function (config) {
    //添加请求头
    config.headers.token = '123';
    console.log(instance.headers);
    return config;
}, function (error) {
    return Promise.reject(error);
})
/**
 * 响应拦截
 */
instance.interceptors.response.use(function (response) {
    const { status, data } = response;
    switch (status) {
        case 200:
        case 201:
            console.log('请求成功' + status)
            console.log(data)
            return data;
            break;
        default:
            return false;

            break;
    }

}, function (response) {
    console.log(response);

    // 对响应错误做点什么 （statusCode !== 200）
    const {
        status,
        data
    } = response.request;
    switch (status) {
        case 401:
            console.log('token过期');
            return Promise.reject(response)
            // 假设201为token失效，这里跳转登录
            break;
        case 422:
            console.log('错误请求422');
            // console.log(data)
            const {
                errors
            } = data

            console.log(errors)
            // vm.$u.showToast(Object.values(errors)[0][0])
            // console.log(Object.values(errors)[0][0])
            vm.$u.toast(Object.values(errors)[0][0])
            return Promise.reject(response)
            break;
        case 400:
            // 错误请求
            console.log('错误请求400');
            return Promise.reject(response)
            break;
        default:
            console.log('其他错误'+status);
            // 如果返回false，则会调用Promise的reject回调，
            // 并将进入this.$u.post(url).then().catch(res=>{})的catch回调中，res为服务端的返回值
            return Promise.reject(response)
            break;
    }
    return Promise.reject(response)
})
/**
 * get请求
 * @param {} url 
 * @param {*} params 
 * @returns 
 */
export function get(url, params) {
    return instance.get(url, { params })
}
/**
 * poast请求
 * @param {} url 
 * @param {*} params 
 * @returns 
 */
export function post(url, params) {
    // let data = {
    //     'Content-Type': 'application/json11;',
    // }
    // instance.head = data
    return instance.post(url, params)
}

/**
 * put请求
 * @param {} url 
 * @param {*} params 
 * @returns 
 */
export function put(url, params) {
    return instance.put(url, params)
}

/**
 * delete请求
 * @param {} url 
 * @param {*} params 
 * @returns 
 */
export function del(url) {
    return instance.delete(url)
}


// WEBPACK FOOTER //
// ./src/utils/reuuest.js